import React from 'react'
import { useEffect } from 'react'
import anime from 'animejs'

export default function Loading() {

    useEffect(() => {
        anime({
            targets: ".cool-svg path",
            duration: 3000,
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: "easeInOutSine",
        })
    }, [])

    return (
        <div>
            <div  className="fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                <svg className="cool-svg p-2 w-32 h-32"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 355 355">
                <path className="p-2"
                    d="M94.215 98.9502V232.225C88.8018 252.45 81.8802 257.444 61.6851 254.513L19.1091 232.225C12.7478 228.944 9.72333 226.573 10.0199 216.759V92.1273C10.8818 83.5272 13.1485 79.9329 19.1091 74.8425L134.399 11.6167C139.256 9.52619 141.98 9.39696 146.837 11.6167L262.605 74.8425C269.982 79.8764 273.038 83.5625 276 92.1273V216.759C275.047 224.176 273.344 227.552 268.346 232.225L146.837 295.451C142.369 297.47 139.663 297.563 134.399 295.451L100.434 276.346M134.399 98.9502V176.479M134.399 216.759V176.479M204.701 98.9502L153.372 155.556M134.399 176.479L153.372 155.556M153.372 155.556L204.701 216.759"
                    style={{'stroke':'#57EDA0','stroke-width':'10px', 'fill':'#1D1C29'}} />
                </svg>
            </div>
        </div>
    )
}
